import { store } from "data/store"
export const AGGIORNA_LISTA_AGENTI = (nomeParametro) => {
    store.dispatch({
        type: 'AGGIORNA_LISTA_AGENTI',
        payload: nomeParametro,
    })
}
